module.exports = __webpack_public_path__ + "static/img/bg-01_2025.6ed590d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg-01_2025.jpg
// module id = lXJp
// module chunks = 100